export { default as translations } from './translations.json';

/**
 * Check if auto-approve is enabled for a listing.
 * @param {Object|null} listing
 * @returns {boolean}
 */
export const isAutoApproveEnabled = (listing) =>
  !!listing?.attributes?.publicData?.autoApprove?.enabled;

/**
 * Get auto-approve config from listing.
 * @param {Object|null} listing
 * @returns {Object|null}
 */
export const getAutoApproveConfig = (listing) =>
  listing?.attributes?.publicData?.autoApprove || null;
